import DateRangePicker from "components/DateRangePicker";
import { DateRangeType } from "../../../types";

interface DateRangeHeaderProps {
  dateRange: DateRangeType | undefined;
  onDateRangeChange: (range: DateRangeType | undefined) => void;
}

export function DateRangeHeader({ dateRange, onDateRangeChange }: DateRangeHeaderProps) {
  return (
    <DateRangePicker
      date={dateRange}
      onDateChange={onDateRangeChange}
      className="h-10"
      allowUnlimited
    />
  );
}
